module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAfElEQVR4Ae3NAQaDABxG8WA0G2N3GrOBCAjoTt0jAAGCgNAdukSlF/gDEPokvt8B3kvsMGZGSqrM32lpuKnyDzoA2YKKoFnwpFcvXnsXXgzqxXvvwouRUCsGJWHio8ivF84Xp+Wdz9X5RZIPZMyifODPJMoHfnwTM7PL2gDEMxs/ye4NGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Datebox/baseline_keyboard_arrow_right_white_24dp.png
// module id = 95
// module chunks = 0